const publishers = [
    {
        label: 'Oficyna Wydawnicza ATUT',
        path: 'http://www.atut.ig.pl',
    },
    {
        label: 'Uniwersytet Wrocławski',
        path: 'https://uni.wroc.pl',
    },
];

export default publishers;
